/**
 * Created by ZXW on 2018/2/26.
 */
import { Message } from 'element-ui'
// 配置API接口地址
// var root = 'http://192.168.5.178:8082/';
var root = 'http://ebusadapi.ipubtrans.com/'
// var root = 'http://119.23.8.54:8082/'; // 生产
// 配置API接口地址
// 引用axios
var axios = require('axios')
// 自定义判断元素类型JS
function toType (obj) {
  return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase()
}
// 参数过滤函数
function filterNull (o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key]
    }
    if (toType(o[key]) === 'string') {
      o[key] = o[key].trim()
    } else if (toType(o[key]) === 'object') {
      o[key] = filterNull(o[key])
    } else if (toType(o[key]) === 'array') {
      o[key] = filterNull(o[key])
    }
  }
  return o
}
/*
 接口处理函数
 这个函数每个项目都是不一样的，我现在调整的是适用于
 https://cnodejs.org/api/v1 的接口，如果是其他接口
 需要根据接口的参数进行调整。参考说明文档地址：
 https://cnodejs.org/topic/5378720ed6e2d16149fa16bd
 主要是，不同的接口的成功标识和失败提示是不一致的。
 另外，不同的项目的处理方法也是不一致的，这里出错就是简单的alert
 */

function apiAxios (method, url, params, success, failure) {
  if (params) {
    params = filterNull(params)
  }
  axios({
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
    baseURL: root,
    withCredentials: false,
    timeout: 10000,
    headers: { 'token': sessionStorage.getItem('token') }
  })
    .then(function (res) {
      if (res.status === 200) {
        success(res.data)
      } else {
        Message.error(res.data.userMessage || '系统异常,请重试!')
      }
    })
    .catch(function (err) {
      if (err.message.indexOf('timeout') !== -1) {
        Message.error('请求超时,请重试!')
      }
    })
}

// 返回在vue模板中的调用接口
export default {
  root,
  get: function (url, params, success, failure) {
    return apiAxios('GET', url, params, success, failure)
  },
  post: function (url, params, success, failure) {
    return apiAxios('POST', url, params, success, failure)
  },
  overdue: function (code, mess) {
    if (code === 545) {

    }
  }
}



// WEBPACK FOOTER //
// ./src/js/api.js